module.exports = __webpack_public_path__ + "img/6.1c6a22ef.jpg";